import React from "react";
import Page from "../components/Page";
import UpdatePersonForm from "../components/forms/UpdatePersonForm";
import UpdateEmployeeForm from "../components/forms/UpdateEmployeeForm";
import UpdatePasswordForm from "../components/forms/UpdatePasswordForm";
import CenteredPageContentContainer from "../components/CenteredPageContentContainer";
import PaperContainer from "../components/PaperContainer";
import UpdateAppSettingsForm from "../components/forms/UpdateAppSettingsForm";
import CompanyForm from "../components/forms/CompanyForm";
import { FormMode } from "../types/enums";

let credentials = JSON.parse(localStorage.getItem("credentials"));

const MyAccountPage = () => (
  <Page title="Mijn account">
    <CenteredPageContentContainer>
      <PaperContainer title="Gegevens wijzigen">
        {(() => {
          switch (credentials.user.type) {
            case "PERSON":
              return <UpdatePersonForm id={credentials.user.email} />;
            case "COMPANY":
              return (
                <CompanyForm
                  companyEmail={credentials.user.email}
                  mode={FormMode.UPDATE}
                />
              );
            case "EMPLOYEE":
              return (
                <UpdateEmployeeForm employeeEmail={credentials.user.email} />
              );
            default:
              null;
          }
        })()}
      </PaperContainer>
      <PaperContainer title="Wachtwoord wijzigen">
        <UpdatePasswordForm id={credentials.user.email} />
      </PaperContainer>
      {credentials.user.isAdmin && (
        <PaperContainer title="App instellingen wijzigen">
          <UpdateAppSettingsForm />
        </PaperContainer>
      )}
    </CenteredPageContentContainer>
  </Page>
);

export default MyAccountPage;



// WEBPACK FOOTER //
// ./src/pages/MyAccountPage.js